
import { useTranslation } from 'react-i18next';
import CommonDescription from '../../components/CommonDescription';
import CommonIconButton from '../../components/CommonIconButton';
import Context from '../../provider';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import React, { useContext, useEffect, useState } from 'react';
import ToggleGroupComponent from '../../components/ToggleGroupComponent';
import UploadComponent from '../../components/UploadComponent';
import './index.scss';

export default function TierInfoSubmitComponent(props) {
  const {
    membershipRecord,
    content,
    fileInfo = null,
    onUploadFile,
    onNext
  } = props;

  const { t } = useTranslation();

  const { lang, isMobile, dispatch } = useContext(Context);

  const [membershipFormRecord, setMembershipFormRecord] = useState(null);
  const [pageContentData, setPageContentData] = useState({});
  const [formFile, setFormFile] = useState(null);

  const [activeNext, setActiveNext] = React.useState(false);

  const paymentPreferenceList = [
    { value: 'back-in', label: t('registration.backIn'), data: 'back-in' },
    { value: 'cheque', label: t('registration.cheque'), data: 'cheque' }
  ];

  useEffect(() => {
    console.log('activeNext', activeNext);

  }, [activeNext]);

  useEffect(() => {
    if (membershipFormRecord) {
      if (membershipFormRecord.payment_preference === 'back-in') {
        // if (membershipFormRecord.payment_images) {
        //   if (Array.isArray(membershipFormRecord.payment_images)) {
        //     setActiveNext(!!membershipFormRecord.payment_images[0]);
        //     return;
        //   }
        // }

        // setActiveNext(!!membershipFormRecord.payment_images);
        setActiveNext(true);
      } else {
        setActiveNext(true);
      }
    } else {
      setActiveNext(false);
    }
  }, [membershipFormRecord]);

  useEffect(() => {
    if (content) {
      setPageContentData(content);
    }
  }, [content]);

  useEffect(() => {
    if (fileInfo) {
      setFormFile(fileInfo);
    }
  }, [fileInfo]);

  useEffect(() => {
    if (membershipRecord) {
      setMembershipFormRecord(membershipRecord);
    }
  }, [membershipRecord]);

  /**
   * 文件上传
   */
  const handleFileUpload = (file, type) => {
    onUploadFile(file);
    setMembershipFormRecord({ ...membershipFormRecord, [type]: file });
  };

  const getPaymentPreference = (value) => {
    let paymentPreference = !!value && value !== 'back-in' ? 'cheque' : 'back-in';
    return paymentPreference;
};

  return (
    <>
      {
        membershipFormRecord &&
        <>
          <div className={`${isMobile ? 'mobile' : 'web'}-money-text-cont`}>
            <span>{t('registration.amount-total')}</span>
            <div className="money-text">
              <span className="original-money-text">
                { membershipFormRecord.net_amount !== membershipFormRecord.membership_fee ? `$${membershipFormRecord.membership_fee}` : ''}
              </span>
              <span className="discounted-money-text">{`$${membershipFormRecord.net_amount}`}</span>
            </div>
          </div>
          {
            pageContentData.sections && pageContentData.sections.length > 0 &&
            <div className={`${isMobile ? 'mobile' : 'web'}-desc`}>
              <CommonDescription data={pageContentData.sections[0].content?.[lang]} />
            </div>
          }
          <div
            className={isMobile ? 'mobile-payment-preference' : "web-payment-preference"}
            style={{ width: isMobile ? undefined : '28.03125rem' }}
          >
            <div className="title-content-cont">
              <div className="title-text">
                {t('registration.paymentPreferenceTitle')}
              </div>
              <div className="content-text">
                {t('registration.paymentPreferenceDesc')}
              </div>
            </div>
            <ToggleGroupComponent
              isChange={false}
              defaultValue={getPaymentPreference(membershipFormRecord['payment_preference'])}
              groupList={paymentPreferenceList}
              onChange={(value) => {
                console.log('paymentPreferenceList value', value);
                setMembershipFormRecord({ ...membershipFormRecord, payment_preference: value });
              }}
            />
          </div>
          {
            membershipFormRecord['payment_preference'] === 'back-in' &&
            <UploadComponent
              componentClass={`${isMobile ? 'mobile' : 'web'}-upload-cont`}
              onChangeFile={(fileData) => {
                handleFileUpload(fileData, 'payment_images');
              }}
              onError={(err) => {
                dispatch({
                  type: 'SET_ERROR_DIALOG',
                  payload: { open: true, message: t(err) }
                });
              }}
              fileNameText={ formFile ? formFile.name : null}
              uploadTitleText={t('common.upload-title')}
              fileTitleText={t('registration.payment_file_title')}
              acceptText="image/png, image/jpg, image/jpeg, .pdf"
              descText={t('common.upload-desc')}
              uploadText={t('common.upload')}
            />
          }
        </>
      }
      <div className="full-width">
        <CommonIconButton
          text={t('common.next-btn')}
          endIcon= {<KeyboardArrowRightIcon />}
          disabled={!activeNext}
          backgroundColor= {!activeNext ? '#C6C6C5' : '#004899'}
          btnColor = "#ffffff"
          btnWidth= { isMobile ? '8.75rem' : "15.26rem"}
          padding = { isMobile ? "0.375rem 1.75rem" : "0.625rem 3rem"}
          btnFontSize = { isMobile ? "1.125rem" : "1.9375rem"}
          btnFontWeight = { isMobile ? "700" : "500"}
          onClick={(e) => {
            e.stopPropagation();
            onNext(membershipFormRecord);
          }}
        />
      </div>
    </>
  );
}